export default "__VITE_ASSET__DiQWcU3e__"